module.exports = __webpack_public_path__ + "img/bg1.229763db.jpg";